import React from "react";

function OthersList({ others, handleClick }) {
  const [selectedId, setSelectedId] = React.useState(null);

  function _handleFunction(item) {
    handleClick(item);
    setSelectedId(item.id);
  }

  return (
    <div className="row g-3">
      {others.map((item) => {
        const isSelected = selectedId === item.id;

        return (
          <div className="col-md-4 col-sm-6" key={item.id}>
            <div
              className="border rounded p-4 text-center shadow-sm"
              onClick={() => _handleFunction(item)}
              style={{
                backgroundColor: isSelected ? "#d18237" : "white",
                color: isSelected ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <strong>{item.name}</strong>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default OthersList;
